export default ({ permissions: { products = {} } = {} }) => products.xtm
